import type { ComputedRef } from 'vue'
import type Vue from 'vue'
import { computed, getCurrentInstance } from 'vue'

interface useX {
  query: ComputedRef<string>
  setQuery: (query: string) => void
  setQueryFromUrl: (query: string) => void
  clearQuery: () => void
}

export function useX(): useX {
  const {
    proxy: { $x },
  } = getCurrentInstance() as { proxy: Vue }

  const query = computed<string>(() => $x.query.search)

  function setQuery(query: string): void {
    $x.emit('UserAcceptedAQuery', query)
  }

  function setQueryFromUrl(query: string): void {
    $x.emit('ParamsLoadedFromUrl', {
      query,
      page: 1,
      filter: [],
      sort: '',
      tag: [],
      scroll: '',
    })
  }

  function clearQuery(): void {
    $x.emit('UserPressedClearSearchBoxButton')
  }

  return {
    query,
    setQueryFromUrl,
    setQuery,
    clearQuery,
  }
}
